/**
 * Tokens for the Create task modal, taken from the approved "1b Two-pane"
 * design (Claude Design project d0d0dce6, `Create Task Modal.dc.html`). Kept in
 * one place so the modal, its rail fields and the checklist can't drift apart.
 */
export const CREATE_TASK = {
  ink: '#21303C',
  muted: '#5B6B79',
  subtle: '#8494A1',
  faint: '#93A1AD',
  body: '#3C4C59',
  line: '#D7DEE5',
  hairline: '#E9EEF3',
  rule: '#EDF1F5',
  divider: '#E4EAF0',
  railBg: '#F7FAFC',
  blue: '#2A6BB0',
  blueDeep: '#1B4F7D',
  blueSoft: '#EAF2FA',
  blueRing: '0 0 0 3px rgba(42,107,176,0.15)',
  patientAvatar: '#E2542A',
  patientChipBg: '#FAF2EF',
  patientChipBorder: '#F0DFD8',
  patientChipText: '#9A5138',
  /** PD-1931 — a missing required field (task name, board). */
  error: '#D92D20',
} as const

/** Section heading above a group of fields ("CHECKLIST", "PROPERTIES"). */
export const SECTION_LABEL_STYLE = {
  fontSize: 11.5,
  fontWeight: 700,
  letterSpacing: '0.09em',
  textTransform: 'uppercase',
  color: CREATE_TASK.faint,
} as const

/** Label sitting directly above a rail control. */
export const FIELD_LABEL_STYLE = {
  fontSize: 12.5,
  fontWeight: 600,
  color: CREATE_TASK.muted,
} as const

/** Shared metrics for the rail's select / date inputs. */
export const RAIL_INPUT_STYLE = {
  height: 38,
  minHeight: 38,
  borderRadius: 9,
  borderColor: CREATE_TASK.line,
  fontSize: 14,
  color: CREATE_TASK.ink,
} as const
